import './styles';

export type {UITextStyles} from './styles';
export * from './UIText';